import { useEffect, useRef } from 'react'

export default function BackgroundMusicController() {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const isMusicOnRef = useRef(false)

  useEffect(() => {
    const cleanupAudio = () => {
      const audio = audioRef.current
      if (audio) {
        audio.pause()
        audio.src = ''
        audioRef.current = null
      }
    }

    const toggle = async () => {
      try {
        const url = '/background.mp3'
        let audio = audioRef.current

        if (!audio) {
          audio = new Audio(url)
          audio.loop = true
          audio.volume = 0.5
          audioRef.current = audio
        }

        if (audio.paused) {
          await audio.play()
          isMusicOnRef.current = true
          window.dispatchEvent(new CustomEvent('digigo-music-changed', { detail: { isMusicOn: true } }))
        } else {
          audio.pause()
          isMusicOnRef.current = false
          window.dispatchEvent(new CustomEvent('digigo-music-changed', { detail: { isMusicOn: false } }))
        }
      } catch {
        isMusicOnRef.current = false
        window.dispatchEvent(new CustomEvent('digigo-music-changed', { detail: { isMusicOn: false } }))
      }
    }

    const onToggleMusic = () => {
      void toggle()
    }

    window.addEventListener('digigo-music-toggle', onToggleMusic)
    window.dispatchEvent(new CustomEvent('digigo-music-changed', { detail: { isMusicOn: isMusicOnRef.current } }))

    return () => {
      window.removeEventListener('digigo-music-toggle', onToggleMusic)
      cleanupAudio()
    }
  }, [])

  return null
}
